// Owner: P1 piece 3 "Omnibar and search" (docs/FILE-OWNERSHIP.md). The omnibar mount (docs/CONTRACTS.md section 16):
// the shell renders <Omnibar open onOpenChange /> once inside the app frame and owns the open state, ⌘K / Ctrl+K and
// the top-bar trigger. The palette (cmdk and its dialog) loads as its own chunk on the first opening, so it costs the
// initial route nothing; once loaded it stays mounted, so closing animates out.
import { Suspense, lazy, useState } from 'react'
import type { OmnibarProps } from '../feature.ts'

const Palette = lazy(() => import('./Palette.tsx'))

export function Omnibar(props: OmnibarProps) {
  const [wanted, setWanted] = useState(props.open)
  if (props.open && !wanted) setWanted(true)
  if (!wanted) return null
  return (
    <Suspense fallback={null}>
      <Palette {...props} />
    </Suspense>
  )
}
